module.exports = __webpack_public_path__ + "img/core3.1e34dc76.png";